var chunkMapping = {
	"0": [
		4727
	],
	"3": [
		4193
	],
	"74": [
		5141
	],
	"153": [
		5220
	],
	"154": [
		5221
	],
	"157": [
		5224
	],
	"158": [
		5225
	],
	"159": [
		5226
	],
	"160": [
		5227
	],
	"161": [
		5228
	],
	"162": [
		5229
	],
	"163": [
		5230
	],
	"164": [
		5231
	],
	"165": [
		5232
	],
	"166": [
		5233
	],
	"167": [
		5234
	],
	"168": [
		5235
	],
	"169": [
		5236
	],
	"170": [
		5237
	],
	"171": [
		5238
	],
	"172": [
		5239
	],
	"173": [
		5240
	]
};
var idToExternalAndNameMapping = {
	"4193": [
		"default",
		"./nuorder-components",
		4022
	],
	"4727": [
		"default",
		"./Containers",
		3799
	],
	"5141": [
		"default",
		"./OrderlessInvoices",
		3799
	],
	"5220": [
		"default",
		"./AsyncEventTracker",
		3799
	],
	"5221": [
		"default",
		"./HostWrapper",
		3799
	],
	"5224": [
		"default",
		"./CheckoutV3",
		3799
	],
	"5225": [
		"default",
		"./CheckoutConfirmation",
		3799
	],
	"5226": [
		"default",
		"./ContactCreditCards",
		3799
	],
	"5227": [
		"default",
		"./AuditDialog",
		3799
	],
	"5228": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3799
	],
	"5229": [
		"default",
		"./InvoiceDialog",
		3799
	],
	"5230": [
		"default",
		"./PaymentDueModal",
		3799
	],
	"5231": [
		"default",
		"./PaymentModal",
		3799
	],
	"5232": [
		"default",
		"./PaymentHistory",
		3799
	],
	"5233": [
		"default",
		"./PaymentConfigurations",
		3799
	],
	"5234": [
		"default",
		"./PaymentPreferences",
		3799
	],
	"5235": [
		"default",
		"./ManagePaymentProcessing",
		3799
	],
	"5236": [
		"default",
		"./MobilePaymentsWrapper",
		3799
	],
	"5237": [
		"default",
		"./Challenge",
		3799
	],
	"5238": [
		"default",
		"./ManagePaymentMethods",
		3799
	],
	"5239": [
		"default",
		"./LightspeedReports",
		3799
	],
	"5240": [
		"default",
		"./ShippingPromotionsListContainer",
		3799
	]
};
var idToRemoteMap = {
	"4193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4022
		}
	],
	"4727": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5220": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5221": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5224": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5225": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5226": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5227": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5228": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5229": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5230": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5231": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5232": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5233": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5234": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5235": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5236": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5237": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5238": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5239": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	],
	"5240": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3799
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}